import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scopeHours", "durationDetails"]

  connect() {
    this.durationDetailsManuallyChanged = false

    if (this.hasDurationDetailsTarget) {
      this.durationDetailsTarget.addEventListener("change", this.markManualChange)
    }

    this.sync()
  }

  disconnect() {
    if (this.hasDurationDetailsTarget) {
      this.durationDetailsTarget.removeEventListener("change", this.markManualChange)
    }
  }

  sync() {
    if (!this.hasScopeHoursTarget || !this.hasDurationDetailsTarget) return
    if (this.durationDetailsManuallyChanged) return

    const scopeHours = this.numberFromInput(this.scopeHoursTarget)
    if (scopeHours === null) return

    const autoValue = this.durationValueFor(scopeHours)
    if (!autoValue) return
    if (!this.optionExists(autoValue)) return
    if (this.durationDetailsTarget.value && this.durationDetailsTarget.value !== this.durationDetailsTarget.dataset.autoValue) return

    this.durationDetailsTarget.value = autoValue
    this.durationDetailsTarget.dataset.autoValue = autoValue
    this.durationDetailsTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  markManualChange = () => {
    this.durationDetailsManuallyChanged = this.durationDetailsTarget.value !== this.durationDetailsTarget.dataset.autoValue
  }

  durationValueFor(scopeHours) {
    if (scopeHours <= 15) return "Krátkodobý (do 15h)"
    if (scopeHours <= 100) return "Střednědobý (16 - 100h)"

    return "Dlouhodobý (100h a více)"
  }

  numberFromInput(input) {
    const value = input.value.trim().replace(",", ".")
    if (value.length === 0) return null

    const number = Number(value)
    return Number.isFinite(number) && number >= 0 ? number : null
  }

  optionExists(value) {
    return Array.from(this.durationDetailsTarget.options).some((option) => option.value === value)
  }
}
